const SIZE_PX = { sm: 24, md: 40, lg: 64 };

export default function LoadingSpinner({ size = 'md', label = 'Loading' }) {
  const px = SIZE_PX[size] || SIZE_PX.md;
  const border = size === 'lg' ? 4 : size === 'sm' ? 2 : 3;
  return (
    <div
      role="status"
      aria-label={label}
      className="flex w-full items-center justify-center py-8"
    >
      <div
        style={{ width: px, height: px, borderWidth: border }}
        className="animate-spin rounded-full border-gray-200 border-t-sky-500 dark:border-night-card dark:border-t-sky-400"
      />
      <span className="sr-only">{label}</span>
    </div>
  );
}
